import { Box, Button } from "@mui/material"
import styled from "styled-components"
import { useNavigate } from "react-router-dom"

export default function CoverPageLunch({}) {

    const navigate = useNavigate();

    function handleButtonClick(page) {
        if(page == "brunch") {
            navigate("/restaurants/menus/lunchroom/brunch")
        }
        if(page == "lunch") {
            navigate("/restaurants/menus/lunchroom/lunch")
        }
        
    }

    return (
        <CoverContainerStyled>
            <Box sx = {{
                width: "40%", 
                maxWidth: "800px",
                display: "flex",
                alignContent: "center",
                justifyContent: "center",
                flexDirection: "column",
                gap: "100px"
                }}>
                <Box>
                    <img src = "/menuCovers/LUNCHROOM.png" style={{width: "100%"}}/>
                </Box>
                <ButtonContainerStyled>
                    <Button onClick = {() => handleButtonClick("brunch")} sx = {{marginBottom: "20px"}}>
                        <img src = "/menuCovers/breakfast.png" style = {{width: "100%"}}/>
                    </Button>
                    <Button onClick = {() => handleButtonClick("lunch")}>
                        <img src = "/menuCovers/dinner.png" style = {{width: "100%"}}/>
                    </Button>
                </ButtonContainerStyled>
         
            </Box>
            <FooterContainerStyled>
                <Box sx = {{
                    fontFamily: "Courier New Bold",
                    color: "#d7352f"
                }}>
                    <p>
                        THE FOOD PREPARED HERE CONTAINS NUTS.
                        <br></br>
                        PLEASE ASK YOU WATER FOR ASSISTANCE.
                    </p>
                </Box>
                <Box sx = {{
                    marginTop: "0px",
                    fontFamily: "Courier New",
                    color: "#1D1D1B"
                }}>
                    <p>
                        MEAT SOURCE BEEF: USA-ASTRALIA-QATAR //
                        <br></br>
                        CHICKEN: BRAZIL-UAE // LAMB: QATAR-AUSTRALIA
                    </p>
                </Box>
            </FooterContainerStyled>
        </CoverContainerStyled>
    )
}

const CoverContainerStyled = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: #CEC6BF;
    width: 100%;
    height: 100vh;
`

const ButtonContainerStyled = styled.div`
    position: relative;
`

const FooterContainerStyled = styled.div`
   margin-top: 100px;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   width: 60%;
   text-align: center;
   font-size: 9px;
`